<template>
	<j-expendable-box class="bg5 b1 bc7 r2">
		<div slot="header" class="pl3 pr3 pt4 pb4 lh125 fs4 c1 fw7">
			{{ $t("commissions") }}
		</div>
		<div class="bt1 bc7 p4" slot="body">
			<!-- TODO: hack - disabling showing adding commission for now -->
			<j-card class="bg5">
				<!-- Headline -->
				<div
					class="xs-12 flex wrap xs-between bg4--l5 p4 bb1 bc7 radius-top mb4"
				>
					<div class="fs5 lh125 c6 fw7">{{ $t("commission_rules") }}</div>
				</div>

				<!-- Dynamic fields -->
				<div
					class="flex wrap xs-12 pl4 pr4 lg-pr0 mb6 lg-mb2"
					v-for="(item, i) in commissionSplit"
					:key="i"
				>
					<!-- Select user or organization -->
					<div class="flex wrap xs-12 lg-4 pr1 xs-middle mb1 lg-mb0">
						<span class="pr2 fw7 fs3 c6">{{ i + 1 }}</span>
						<div class="xs">
							<!-- If no id, show options to select what to add - organization vs internal -->
							<div
								v-if="
									item.person && item.person[0] && item.person[0].id === null
								"
								class="fs3 p2 bg4 r1 lh125"
							>
								<!-- Select organization or internal -->
								{{ $t("commission_for") }}
								<j-button
									size="small"
									type="tertiary"
									@click="
										organizationOrInternal = 'organization'
										item.person = []
									"
									>{{ $t("organization") }}</j-button
								>
								{{ $t("or") }}
								<j-button
									size="small"
									type="tertiary"
									@click="
										organizationOrInternal = 'internal'
										item.person = []
									"
									>{{ $t("participant") }}</j-button
								>
							</div>

							<!-- TODO: IT;s bit hacky, we had to tweak quickly for Asia Insurance -->
							<!-- What thi does is if commission is already assigned and it's for organization 
						it shows core-select-organizations. If nothing was assigned yet and user is in the process 
						of creation of commission rule and he picked organizationOrInternal as organization, it shows core-select-organizations 
						The same applies for internals.-->
							<core-select-organizations
								v-if="
									(item.person.length === 0 &&
										organizationOrInternal === 'organization') ||
										(item.person[0] &&
											item.person[0].__typename === 'organization')
								"
								size="small"
								v-model="item.person"
								@input="updateRule(item.id)"
							/>
							<core-select-internals
								v-if="
									(item.person.length === 0 &&
										organizationOrInternal === 'internal') ||
										(item.person[0] && item.person[0].__typename === 'internal')
								"
								size="small"
								v-model="item.person"
								@input="updateRule(item.id)"
							/>
						</div>
					</div>

					<!-- Rule type selection -->
					<div class="xs-12 lg-4 mb1 lg-mb0">
						<j-base-select
							size="small"
							:options="ruleOptions"
							v-model="item.ruleType"
							@input="
								item.value = null
								item.basedOnRuleId = null
								updateRule(item.id)
							"
							:placeholder="`-- ${$t('select_type')}`"
						/>
					</div>

					<!-- Flat -->
					<div
						class="xs-11 lg-3 flex mb1 lg-mb0"
						v-if="item.ruleType === 'flat'"
					>
						<div class="xs-6 lg-pl1">
							<j-base-input-number
								type="float"
								size="small"
								v-model="item.value"
								@blur="updateRule(item.id)"
								:placeholder="$t('amount')"
							/>
						</div>
						<div class="xs-6 pl1">
							<crm-select-currency
								size="small"
								v-model="item.currencyCode"
								@input="updateRule(item.id)"
								:placeholder="$t('currency')"
							/>
						</div>
					</div>

					<!-- Ratio on premium -->
					<div
						class="xs-11 lg-3 flex mb1 lg-mb0"
						v-else-if="item.ruleType === 'ratio'"
					>
						<div class="flex xs-12 lg-pl1 xs-middle">
							<j-base-input-number
								size="small"
								:min="0"
								:max="100"
								v-model="item.value"
								@blur="updateRule(item.id)"
								:placeholder="$t('%_of_premium')"
							/>
							<span class="pl1">%</span>
						</div>
					</div>

					<!-- Ratio on rule -->
					<div
						class="xs-11 lg-3 flex mb1 lg-mb0"
						v-if="item.ruleType === 'ratioBasedOnOtherRule'"
					>
						<div class="xs-7 lg-pl1">
							<j-base-select
								size="small"
								:options="getOptionsForRuleSelection(i)"
								v-model="item.basedOnRuleId"
								@input="updateRule(item.id)"
								:placeholder="`-- ${$t('rule')}`"
								:allowSelectNothing="false"
							/>
						</div>
						<div class="flex xs-5 pl1 xs-middle">
							<j-base-input-number
								size="small"
								:min="0"
								:max="100"
								v-model="item.value"
								@blur="updateRule(item.id)"
								placeholder="%"
							/>
							<span class="pl1">%</span>
						</div>
					</div>

					<!-- Delete -->
					<div class="flex xs-1 xs-middle xs-center">
						<crm-icon
							name="delete"
							class="cu2"
							color="cError"
							@click.native="removeRule(i)"
						/>
					</div>
				</div>

				<!-- Message -->
				<div class="pl4 pr4 mb2" v-if="message" @click.native="message = null">
					<div class="p2 bgError ta2 c5 fs3">{{ message }}</div>
				</div>

				<!-- Add Rule -->
				<div class="flex xs-center pl4 pr4 pt2 pb2 mb2">
					<j-button type="fifth" size="small" @click="addRule">
						<crm-icon name="add" class="cu2" color="c1" size="small" />
						{{ $t("add_rule") }}
					</j-button>
				</div>
			</j-card>

			<!-- Summary -->
			<j-card class="bg5 mt4" v-if="commissionSummary.length > 0">
				<!-- Headline -->
				<div
					class="xs-12 flex wrap xs-between bg4--l5 p4 bb1 bc7 radius-top mb4"
				>
					<div class="fs5 lh125 c6 fw7">{{ $t("summary") }}</div>
				</div>

				<!-- Body -->
				<div class="xs-12 p4">
					<div
						class="flex xs-12 xs-between pt4 pb4"
						v-for="(item, i) in commissionSummary"
						:key="i"
					>
						<div class="xs-4 ta1">
							{{ item.entity ? item.entity.name : "---" }}
						</div>
						<div class="xs-4 ta2">
							{{ (item.ratio * 100).toFixed(2) }}% {{ $t("of_premium") }}
						</div>
						<div class="xs-4 ta3 fw7">
							{{ item.currencyCode }}{{ item.amount }}
						</div>
					</div>
				</div>
			</j-card>
		</div>
	</j-expendable-box>
</template>

<script>
/**
 * This component is an old one that was migrating from old policies,
 * it's only for manual commission split per policy. Probably not used by anyone haha. Good for demo though.
 * It's bit big but we keep it all in one component for now as we are not sure about the future of this feature at all.
 * It will receive policyId prop and based on it ti will fetch rules and do updates of rules
 */
import JExpendableBox from "@/components/JExpendableBox"
import JCard from "@/components/JCard/"
import JButton from "@/components/JButton/"
import JBaseInputNumber from "@/components/JBaseInputNumber/"
import JBaseSelect from "@/components/JBaseSelect/"
import CoreSelectInternals from "@/modules/core/components/CoreSelectInternals"
import CoreSelectOrganizations from "@/modules/core/components/CoreSelectOrganizations"
import CrmIcon from "@/components/CrmIcon/"
import CrmSelectCurrency from "@/components/CrmSelectCurrency/"

import api from "@/api/gql.js"
import { gql } from "@/api/utils.js"

export default {
	components: {
		JCard,
		JButton,
		CrmIcon,
		CrmSelectCurrency,
		JExpendableBox,
		CoreSelectInternals,
		CoreSelectOrganizations,
		JBaseSelect,
		JBaseInputNumber
	},

	data() {
		return {
			// Will be populated from fetch
			commissionSplit: [],
			commissionSummary: [],

			message: null,
			timeout: null,

			// Helper to switch between organization and internal
			organizationOrInternal: null
		}
	},

	computed: {
		ruleOptions() {
			let output = [
				{ name: this.$t("flat_fee"), value: "flat" },
				{ name: this.$t("%_of_premium"), value: "ratio" }
			]

			// If there is only one rule, don't allow to select "based on rule" ruleType
			if (this.commissionSplit.length > 1)
				output.push({
					name: this.$t("%_of_result_of_rule"),
					value: "ratioBasedOnOtherRule"
				})

			return output
		}
	},

	methods: {
		async addRule() {
			this.commissionSplit.push({
				value: 0,
				ruleType: "ratio",
				currencyCode: this.$store.state.settings.preferredCurrency,
				person: [
					{
						id: null,
						name: null
					}
				]
			})

			const query = gql`
				mutation addCommissionToOffer(
					$caseId: String!
					$proposalId: String!
					$offerId: String!
					$input: commissionInput!
				) {
					addCommissionToOffer(
						caseId: $caseId
						proposalId: $proposalId
						offerId: $offerId
						input: $input
					) {
						status
						errors
					}
				}
			`

			const variables = {
				caseId: this.$store.state.caseManagement.caseId,
				proposalId: this.$store.state.caseManagement.proposalId,
				offerId: this.$store.state.caseManagement.offerId,
				input: {
					entityId: null,
					jsonRule: '{ "*": [ {"var" : "totalPremium"}, 0 ]}'
				}
			}

			const res = await api({ query, variables })

			// errors
			if (res?.data?.addCommissionToOffer?.status !== "success") {
				this.$store.dispatch("addMessage", {
					message: {
						type: "error",
						text:
							res?.errors ||
							res?.data?.addCommissionToOffer?.errors ||
							res?.data?.addCommissionToOffer?.errors_2.message ||
							"Oops ! An error occured."
					}
				})
			}

			// Refetch all results
			this.fetchRulesAndSummary()
		},

		async updateRule(id) {
			const rule = this.commissionSplit.find(item => item.id === id)

			let jsonRule
			if (rule.ruleType === "ratio")
				jsonRule = `{ "*": [ {"var" : "totalPremium"}, ${parseInt(rule.value) /
					100} ]}`
			else if (rule.ruleType === "flat")
				jsonRule = `[${rule.value ? parseFloat(rule.value) : 0}, "${
					rule.currencyCode
				}"]`
			else if (rule.ruleType === "ratioBasedOnOtherRule")
				jsonRule = `{ "*": [ {"var" : "${rule.basedOnRuleId}"}, ${parseInt(
					rule.value
				) / 100} ]}`

			const query = gql`
				mutation updateCommissionOfOffer(
					$caseId: String!
					$proposalId: String!
					$offerId: String!
					$id: String!
					$input: commissionInput!
				) {
					updateCommissionOfOffer(
						caseId: $caseId
						proposalId: $proposalId
						offerId: $offerId
						id: $id
						input: $input
					) {
						status
						errors
					}
				}
			`

			const variables = {
				caseId: this.$store.state.caseManagement.caseId,
				proposalId: this.$store.state.caseManagement.proposalId,
				offerId: this.$store.state.caseManagement.offerId,
				id: id,
				input: {
					entityId: rule.person && rule.person[0] ? rule.person[0].id : null,
					jsonRule
				}
			}

			const res = await api({ query, variables })

			// errors
			if (res?.data?.updateCommissionOfOffer?.status !== "success") {
				this.$store.dispatch("addMessage", {
					message: {
						type: "error",
						text:
							res?.errors ||
							res?.data?.updateCommissionOfOffer?.errors ||
							res?.data?.updateCommissionOfOffer?.errors_2.message ||
							"Oops ! An error occured."
					}
				})
			}

			// Refetch
			this.fetchRulesAndSummary()
		},

		async removeRule(index) {
			const isRuleDependency = index => {
				// Go through all rules and find if index of rule to be deleted is in some other rule
				return this.commissionSplit.some(
					item => item.basedOnRuleId && `${item.basedOnRuleId}` === `${index}`
				)
			}

			// Before removing, check whether the rule is dependency to some other rule
			// If it is, don't delete but show error
			if (!isRuleDependency(index)) {
				const ruleId = this.commissionSplit[index]
					? this.commissionSplit[index].id
					: null

				// Remove from state
				this.commissionSplit.splice(index, 1)

				const query = gql`
					mutation removeCommissionFromOffer(
						$caseId: String!
						$proposalId: String!
						$offerId: String!
						$id: String!
					) {
						removeCommissionFromOffer(
							caseId: $caseId
							proposalId: $proposalId
							offerId: $offerId
							id: $id
						) {
							status
							errors
						}
					}
				`

				const variables = {
					caseId: this.$store.state.caseManagement.caseId,
					proposalId: this.$store.state.caseManagement.proposalId,
					offerId: this.$store.state.caseManagement.offerId,
					id: ruleId
				}

				const res = await api({ query, variables })

				// errors
				if (res?.data?.removeCommissionFromOffer?.status !== "success") {
					this.$store.dispatch("addMessage", {
						message: {
							type: "error",
							text:
								res?.errors ||
								res?.data?.removeCommissionFromOffer?.errors ||
								res?.data?.removeCommissionFromOffer?.errors_2.message ||
								"Oops ! An error occured."
						}
					})
				}
				// Refetch all results
				this.fetchRulesAndSummary()
			} else this.addMessage(this.$t("errors.this_rule_cant_be_deleted"))
		},

		async fetchRulesAndSummary() {
			const query = gql`
				query commissionSummary(
					$caseWhere: caseWhere
					$proposalWhere: proposalWhere
					$offerWhere: offerWhere
				) {
					cases(where: $caseWhere) {
						list {
							proposals(where: $proposalWhere) {
								basket(where: $offerWhere) {
									commissionSplitRules {
										id
										entity {
											__typename
											id
											name
										}
										baseCommissionRatio {
											ratio
										}
										currencyCode
										amount
										ratio
										type
										entity {
											name
										}
										jsonRule
									}
									commissionSummary {
										currencyCode
										amount
										ratio
										entity {
											__typename
											id
											name
										}
									}
								}
							}
						}
					}
				}
			`

			const variables = {
				caseWhere: { id: this.$store.state.caseManagement.caseId },
				proposalWhere: { id: this.$store.state.caseManagement.proposalId },
				offerWhere: { id: this.$store.state.caseManagement.offerId }
			}

			const res = await api({ query, variables })

			// Parse jsonLogic and get baseId
			const getBaseIdFromJsonLogic = jsonRule => {
				let parsed = null

				try {
					parsed = JSON.parse(jsonRule)
				} catch (e) {}

				return parsed && parsed["*"] && parsed["*"][0]
					? parsed["*"][0].var
					: null
			}

			// Based on what type of rule it is, return proper value
			const getValue = rule => {
				if (rule.type === "ratio") return (rule.ratio * 100).toFixed(0)
				else if (rule.type === "flat") return rule.amount
				else if (
					rule.type === "ratioBasedOnOtherRule" &&
					rule.baseCommissionRatio &&
					rule.baseCommissionRatio.ratio
				)
					return (rule.baseCommissionRatio.ratio * 100).toFixed(0)
				else return 0
			}

			// Assign commissionSummary
			this.commissionSummary =
				res?.data?.cases?.list?.[0].proposals?.[0]?.basket?.[0]?.commissionSummary

			// Convert results to internal data structure
			this.commissionSplit = res?.data?.cases?.list?.[0].proposals?.[0]?.basket?.[0]?.commissionSplitRules.map(
				item => ({
					id: item.id,
					value: getValue(item),
					person: [
						{
							id: item.entity ? item.entity.id : null,
							name: item.entity ? item.entity.name : null,
							__typename: item.entity ? item.entity.__typename : null
						}
					],
					ruleType: item.type,
					currencyCode: item.currencyCode,

					// If it's based on rule Id, get ruleId from jsonLogic
					basedOnRuleId:
						item.type === "ratioBasedOnOtherRule"
							? getBaseIdFromJsonLogic(item.jsonRule)
							: null
				})
			)
		},

		addMessage(message) {
			// Reset timeout
			// In case there is already some timeout running, it might remove new message early
			clearTimeout(this.timeout)

			// Set message
			this.message = message

			// Remove message after some time
			this.timeout = setTimeout(() => {
				this.message = null
			}, 5000)
		},

		getOptionsForRuleSelection(excludedIndex) {
			// Remove rule of excludedIndex, prevent infinit loop
			return this.commissionSplit
				.map((item, i) => ({
					name: `${this.$t("rule")} ${i + 1}`,
					value: item.id
				}))
				.filter((item, i) => `${i}` !== `${excludedIndex}`)
		}
	},

	mounted() {
		this.fetchRulesAndSummary()
	}
}
</script>
